// extracted by css-extract-rspack-plugin
export default {"container":"_77ca49d5","text":"_313eb2cf","tooltipText":"_431edada"};